<template>
  <div class="roles-main">
    <div class="header-container">
      <div class="search">
        <el-select
          v-model="request.loginNameList"
          :placeholder="t('fields.affiliate')"
          multiple
          filterable
          style="margin-right: 10px;"
        >
          <el-button round size="small" @click="toggleAll();" style="margin-left: 15px">{{ isAllSelected ? 'Unselect All' : 'Select All' }}</el-button>
          <el-option
            v-for="aff in affiliateNames.list"
            :key="aff.loginName"
            :label="aff.loginName + ' (' + aff.affiliateCode + ')'"
            :value="aff.loginName"
          />
        </el-select>
        <el-date-picker
          v-model="request.recordTime"
          format="DD/MM/YYYY"
          value-format="YYYY-MM-DD"
          type="daterange"
          range-separator=":"
          :start-placeholder="t('fields.startDate')"
          :end-placeholder="t('fields.endDate')"
          style="width: 250px"
          :shortcuts="shortcuts"
          :disabled-date="disabledDate"
          :editable="false"
          :clearable="false"
        />
        <!-- <el-input
          v-model="request.loginName"
          style="width: 150px; margin-left: 5px"
          :placeholder="t('fields.affiliateName')"
        /> -->
        <el-button
          style="margin-left: 20px"
          icon="el-icon-search"
          type="success"
          @click="loadReport()"
        >
          {{ t('fields.search') }}
        </el-button>
        <el-button
          icon="el-icon-refresh"
          type="warning"
          @click="resetQuery()"
        >
          {{ t('fields.reset') }}
        </el-button>
      </div>
    </div>

    <el-table
      :data="page.records"
      ref="table"
      row-key="id"
      size="small"
      highlight-current-row
      v-loading="page.loading"
      :empty-text="t('fields.noData')"
      style="margin-top:20px;"
      :row-style="{width: '100px'}"
    >
      <el-table-column prop="recordTime" :label="t('fields.recordTime')" width="120" />
      <el-table-column prop="loginName" :label="t('fields.affiliateName')" width="120" />
      <el-table-column prop="registerMemberCount" :label="t('fields.registerCount')" width="120" />
      <el-table-column :label="t('fields.depositRetention')">
        <el-table-column
          prop="depositDay1"
          :label="t('fields.retentionDay1')"
          width="120"
        />
        <el-table-column
          prop="depositDay2"
          :label="t('fields.retentionDay2')"
          width="120"
        />
        <el-table-column
          prop="depositDay3"
          :label="t('fields.retentionDay3')"
          width="120"
        />
        <el-table-column
          prop="depositDay4"
          :label="t('fields.retentionDay4')"
          width="120"
        />
        <el-table-column
          prop="depositDay5"
          :label="t('fields.retentionDay5')"
          width="120"
        />
        <el-table-column
          prop="depositDay6"
          :label="t('fields.retentionDay6')"
          width="120"
        />
        <el-table-column
          prop="depositDay7"
          :label="t('fields.retentionDay7')"
          width="120"
        />
        <el-table-column
          prop="depositDay14"
          :label="t('fields.retentionDay14')"
          width="120"
        />
        <el-table-column
          prop="depositDay30"
          :label="t('fields.retentionDay30')"
          width="120"
        />
      </el-table-column>
      <el-table-column :label="t('fields.regLoginRetention')">
        <el-table-column
          prop="loginDay1"
          :label="t('fields.retentionDay1')"
          width="120"
        />
        <el-table-column
          prop="loginDay2"
          :label="t('fields.retentionDay2')"
          width="120"
        />
        <el-table-column
          prop="loginDay3"
          :label="t('fields.retentionDay3')"
          width="120"
        />
        <el-table-column
          prop="loginDay4"
          :label="t('fields.retentionDay4')"
          width="120"
        />
        <el-table-column
          prop="loginDay5"
          :label="t('fields.retentionDay5')"
          width="120"
        />
        <el-table-column
          prop="loginDay6"
          :label="t('fields.retentionDay6')"
          width="120"
        />
        <el-table-column
          prop="loginDay7"
          :label="t('fields.retentionDay7')"
          width="120"
        />
      </el-table-column>
    </el-table>
    <el-pagination
      :total="page.total"
      :page-sizes="[20, 50, 100, 150]"
      layout="total,sizes,prev, pager, next"
      style="margin-top: 10px"
      v-model:page-size="request.size"
      v-model:page-count="page.pages"
      v-model:current-page="request.current"
      @current-change="loadReport"
      @size-change="loadReport"
    />
  </div>
</template>

<script setup>
import { onMounted, reactive, computed } from 'vue'
import moment from 'moment'
import { getAffiliateRetentionReport } from '@/api/affiliate-retention'
import { getSite } from '@/api/site'
import { getAffiliateList } from '@/api/affiliate-record'
import { useStore } from '@/store'
import { useI18n } from 'vue-i18n'
import { getShortcuts } from '@/utils/datetime'

const { t } = useI18n()
const startDate = new Date()
startDate.setDate(startDate.getDate())
const defaultStartDate = convertDate(startDate)
const defaultEndDate = convertDate(new Date())
const affiliateNames = reactive({
  list: [],
})
const store = useStore()
const page = reactive({
  pages: 0,
  records: [],
  loading: false,
})

const request = reactive({
  size: 30,
  current: 1,
  siteId: null,
  loginName: null,
  recordTime: [defaultStartDate, defaultEndDate],
  loginNameList: null,
})

async function loadSites() {
  const { data: site } = await getSite(store.state.user.siteId)
  request.siteId = site.id

  const { data: affiliates } = await getAffiliateList(store.state.user.id)

  affiliateNames.list = affiliates
}

function convertDate(date) {
  return moment(date).format('YYYY-MM-DD')
}

const shortcuts = getShortcuts(t)
function disabledDate(time) {
  return (
    time.getTime() <
        moment(new Date())
          .subtract(5, 'months')
          .startOf('month')
          .format('x') || time.getTime() > new Date().getTime()
  )
}

function resetQuery() {
  request.recordTime = [defaultStartDate, defaultEndDate]
  request.siteId = store.state.user.siteId
  request.loginName = null
  request.loginNameList = null
}

const isAllSelected = computed(() => {
  return request.loginNameList && request.loginNameList.length > 0 &&
    request.loginNameList.length === affiliateNames.list.length
})

function toggleAll() {
  this.request.loginNameList = this.isAllSelected ? [] : affiliateNames.list.map(a => a.loginName)
}

async function loadReport() {
  page.loading = true
  const requestCopy = { ...request }
  const query = {}
  Object.entries(requestCopy).forEach(([key, value]) => {
    if (value) {
      query[key] = value
    }
  })
  if (request.recordTime !== null) {
    if (request.recordTime.length === 2) {
      query.recordTime = request.recordTime.join(',')
    }
  }
  if (request.loginNameList === null || request.loginNameList.length === 0) {
    query.loginNameList = affiliateNames.list.map(a => a.loginName).join(',')
  } else {
    query.loginNameList = request.loginNameList.join(',')
  }
  const { data: ret } = await getAffiliateRetentionReport(query)
  page.pages = ret.pages
  page.records = ret.records
  page.total = ret.total
  page.loading = false
}

onMounted(async () => {
  await loadSites()
  request.siteId = store.state.user.siteId
  await loadReport()
})
</script>

  <style>
  .el-table .cell {
    word-break: break-word;
    text-overflow: none;
  }
  .warning-row {
    color: #ff0000;
  }
  </style>
